let config = {
    title: 'Jujutsu Kaisen: Unleashed ',
    email: 'support@jujutsukaisenspiritsunleashed.com',
    policy: 'https://jujutsukaisenspiritsunleashed.com/privacy_policy.html',
    term: 'https://jujutsukaisenspiritsunleashed.com/terms.html', 
    copyright: '© 2024 SENSE TECHNOLOGY GROUP LIMITED',
    introduceTitle: [
        'In "Jujutsu Kaisen: Unleashed," players will experience the awe-inspiring power of fully unleashing Cursed Energy, engaging in Domain expansion, and immersing themselves in intense, adrenaline-pumping battles. With 3D graphics, players will feel the thrill and tension of combat firsthand. Facing terrifying Cursed Spirits, only by unleashing their strongest Cursed Energy can they crush them and showcase true dominance and strength.',
        'With stunning graphics, intense gameplay, and a captivating storyline, this game will keep you on the edge of your seat until the very end.'
    ],
    introduceText: [
        {
            title: '------Fully Unleash Cursed Energy-----',
            text: [
                'Unleash powerful Cursed Energy to showcase your strength.'
            ]
        },
        {
            title: '------Expand Domain-----',
            text: [
                'Utilize Domain skills to control the battlefield and leverage combat advantages.'
            ]
        },
        {
            title: '-----Passionate Battles-----',
            text: [
                'Immerse yourself in intense battles, feeling the tension and excitement of each confrontation.'
            ]
        },
        {
            title: '-----3D Graphics------',
            text: [
                'Present stunning 3D graphics to fully immerse players in the game world.'
            ]
        },
        {
            title: '-----Confronting Cursed Spirits------',
            text: [
                'Face terrifying Cursed Spirits, demonstrate your courage and strength to completely crush them.'
            ]
        }
    ]
}
export default config;